import { CheckCircleTwoTone, LinkOutlined } from "@ant-design/icons";
import { Button, Drawer, Empty, Modal, Tooltip, Typography } from "antd";
import { LinkWrapper, LoadingListEntityProfile } from "Explore/Components";
import { useRef, useState } from "react";
import styles from "./FacultyHonor.module.scss";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import { encryptObjectToAsterisk } from "Explore/Utils";
const { Paragraph, Text, Link } = Typography;
const QuotationAndCitation = ({ quotation, citationURL }) => {
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank" rel="noreferrer">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {quotation}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};

const Honor = ({ honor: _honor, data_source_url, encoded }) => {
  const honor = encoded ? encryptObjectToAsterisk(_honor) : _honor;
  return (
    <div className={styles["honor"]}>
      <div className={styles["name"]}>
        <Tooltip title={data_source_url ? "Verified" : "Not yet verified"}>
          <CheckCircleTwoTone
            twoToneColor={data_source_url ? "#52c41a" : "lightgray"}
          />
        </Tooltip>
        <LinkWrapper
          link={data_source_url}
          target="_blank" rel="noreferrer"
          component={
            <div className={styles["title-honor"]}>
              <span>{honor.award_name}</span>
              {honor.award_year && (
                <span className={styles["year"]}>
                  <i>. {honor.award_year}</i>
                </span>
              )}
            </div>
          }
        />
      </div>
      {honor.awarding_organization ? (
        <div className={styles["organization"]}>
          <span>
            <span className={styles["section-title"]}>Organization: </span>
            <span>{honor.awarding_organization}</span>
          </span>
        </div>
      ) : (
        <></>
      )}
      {honor.raw?.length > 0 && (
        <QuotationAndCitation
          quotation={`"...` + honor.raw.join(". ") + `..."`}
          citationURL={data_source_url}
        />
      )}
    </div>
  );
};

const FacultyHonor = ({ data }) => {
  const { userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [minHeight, setMinHeight] = useState(0);
  const ref = useRef(null);
  const isShow = !!userTypeConfig?.ui_components?.honor;

  return (
    <div className={styles["faculty-detail-honors"]}>
      {data.data.length > 0 ? (
        <div className={styles["faculty-detail-honors-landscape"]}>
          <div className={styles["list-honors-title"]}>
            <h2 className={styles["title"]}>Honors</h2>
          </div>
          <LoadingListEntityProfile
            isLoading={data.isLoading}
            component={
              <div
                style={{
                  minHeight,
                  position: "relative",
                }}
              >
                {!isShow && (
                  <LoginRequiredSection
                    blur
                    ref={ref}
                    setHeight={setMinHeight}
                  />
                )}
                {data.data.length > 0 ? (
                  data?.data.slice(0, 3).map((item, index) => {
                    return (
                      <Honor
                        honor={item}
                        key={index}
                        data_source_url={item?.source_url}
                        encoded={!isShow}
                      />
                    );
                  })
                ) : (
                  <Empty description="No Honor Found." />
                )}
                {data.data.length > 3 && (
                  <div className={styles["see-more"]}>
                    <p onClick={() => setIsModalOpen(true)}>
                      See {data.data.length - 3} more
                    </p>
                  </div>
                )}
              </div>
            }
            componentNum={3}
            rows={1}
            avatar={false}
          />
          <Modal
            title="List Honors"
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            width={"70%"}
            style={{
              top: "50px",
            }}
            zIndex={1002}
          >
            <div style={{ overflowY: "auto", height: "500px" }}>
              {data?.data.map((item, index) => {
                return (
                  <Honor
                    honor={item}
                    key={index}
                    data_source_url={item?.source_url}
                  />
                );
              })}
            </div>
          </Modal>
        </div>
      ) : (
        <div></div>
      )}
      <div className={styles["faculty-detail-honors-mobile"]}>
        {data?.data.map((item, index) => {
          return (
            <Honor
              honor={item}
              key={index}
              data_source_url={item?.source_url}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FacultyHonor;
